import type {
  U3202ModelTestRequest,
  U3202OrgModelConfigGridRow,
  U3202OrgProviderConfigFormData,
} from '../U3202Service';
import { u3202ExtractParameterDefaults } from './u3202ParameterFormUtils';

export function u3202BuildModelTestRequest(
  parentData: U3202OrgProviderConfigFormData,
  row: U3202OrgModelConfigGridRow,
): U3202ModelTestRequest {
  const request: U3202ModelTestRequest = {
    modelId: row.modelId,
  };

  if (row.modelCode.trim() !== '') {
    request.modelCode = row.modelCode.trim();
  }

  if (parentData.id) {
    request.providerId = parentData.id;
  }

  if (parentData.apiKeyTouched && parentData.apiKey.trim() !== '') {
    request.apiKey = parentData.apiKey.trim();
  }

  if (parentData.apiUrl.trim() !== '') {
    request.apiUrl = parentData.apiUrl.trim();
  }

  if (row.parameterSchema) {
    const parameterDefaults = u3202ExtractParameterDefaults(row.parameterSchema, row.parameterValues);
    if (Object.keys(parameterDefaults).length > 0) {
      request.parameterDefaults = parameterDefaults;
    }
  }

  return request;
}

export function u3202CanTestModelFromGrid(
  parentData: U3202OrgProviderConfigFormData | null | undefined,
  selectedRowCount: number,
): boolean {
  if (selectedRowCount !== 1 || !parentData) {
    return false;
  }
  if (parentData.id || parentData.hasExistingApiKey) {
    return true;
  }
  return parentData.apiKey.trim() !== '';
}
